import ImageBlock from './image';
import MarkdownText from 'components/atoms/markdown'

function Block({ block }) {
    switch (block.__component) {
        case "content-blocks.rich-text":
            return <MarkdownText prose>{block.text}</MarkdownText>;
        case "content-blocks.image":
            return <ImageBlock block={block} />;
    }

    return null;
}

export default function DynamicZone({ blocks }) {
    return (
        <>
            {blocks.map((block, idx) => (
                <Block key={idx} block={block} />
            ))}
        </>
    )
}
